import { Component, OnInit, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'file360-field-inline-label',
  templateUrl: './field-inline-label.component.html',
  styleUrls: ['./field-inline-label.component.scss']
})
export class FieldInlineLabelComponent implements OnInit {

  /**
   * Label text
   */
  @Input() label: string | undefined = "";

  /**
   * Used to bound this label to a form field.
   */
  @Input() elementId: string | undefined = "";

  /**
  * Whether to show the required field indicator.
  * When true, this overrides checking the form field for a
  * 'required' validator. This property is needed to force
  * the required indicator to be displayed in cases where the
  * 'required' validator is not able to be determined on the NgControl 
  * (for example, when data is set on the field before the field is displayed)
  * Setting to 'false' does not override the validator check, it is the same as undefined.
  */
  @Input() showRequiredIndication: boolean | undefined = false;

  /**
  * Hover tip to show when mouse is hovers over the label.
  */
  @Input() hoverTip: string | undefined = "";


  /**
  * Whether the form field is read-only.
  */
  @Input() readOnly: boolean | undefined = false;

  /**
   * Whether to display the the required indicator
   */
  isRequired: boolean = false;

  constructor(@Optional() public controlDir: NgControl) { }

  ngOnInit() {
    if (this.controlDir !== null && this.controlDir.control !== null && this.controlDir.control.validator) {
      // Checks to see if the required validator is on this control.
      // Sets isRequired property so field label can show the required style.
      const _validator: any = this.controlDir.control.validator(this.controlDir.control);
      this.isRequired = (this.showRequiredIndication === undefined ? false : this.showRequiredIndication) || (_validator !== null && _validator.required);
    } else {
      this.isRequired = this.showRequiredIndication === undefined ? false : this.showRequiredIndication;
    }

    // read-only fields should never appear to be 'required'
    if (this.isRequired) {
      this.isRequired = this.readOnly !== true;
    }
  }
}